import { MutationTree } from 'vuex'
import { NotificationsState } from '@/store/modules/notifications/notificationsTypes'

export const mutations: MutationTree<NotificationsState> = {
  FETCH_LOGIN_VIEW_NOTIFICATION(state, notification) {
    state.loginViewNotification = notification
  },
  FETCH_INTERNAL_MESSAGES(state, messages) {
    state.internalMessages = messages
  },
  FETCH_CONTEXT_INTERNAL_MESSAGES(state, messages) {
    state.contextInternalMessages = messages
  }
}
